"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePriceValue = exports.paymentMappingToRadioOptions = exports.getCurrencyByKey = void 0;
var tslib_1 = require("tslib");
var _ = require("lodash");
var constants_1 = require("../constants");
var currencies_1 = require("./currencies");
var getCurrencyByKey = function (currencyKey) { return currencies_1.CURRENCIES[currencyKey]; };
exports.getCurrencyByKey = getCurrencyByKey;
var paymentMappingToRadioOptions = function (paymentItemsMapping, currency, _a) {
    var t = _a.t;
    return _.reduce(paymentItemsMapping, function (acc, currentValue, currentKey) { return tslib_1.__spreadArray(tslib_1.__spreadArray([], acc, true), [
        {
            label: t("fieldTypes.".concat(constants_1.FormsFieldPreset.GENERAL_ITEMS_LIST, ".itemName"), {
                currency: (0, exports.getCurrencyByKey)(currency).symbol,
                name: currentValue.label,
                price: currentValue.price,
            }),
            value: currentKey,
        },
    ], false); }, []);
};
exports.paymentMappingToRadioOptions = paymentMappingToRadioOptions;
var validatePriceValue = function (_a) {
    var priceValue = _a.priceValue, currencyKey = _a.currencyKey, _b = _a.allowZero, allowZero = _b === void 0 ? false : _b;
    var num = Number(priceValue);
    var isGtZero = allowZero ? num >= 0 : num > 0;
    var isValidNumber = _.isFinite(num) && isGtZero;
    if (!isValidNumber) {
        return isValidNumber;
    }
    var fractionSize = _.size(_.get(_.split(priceValue, '.'), '[1]'));
    var currencyData = (0, exports.getCurrencyByKey)(currencyKey);
    var isValidFractionSize = fractionSize <= currencyData.fraction;
    return isValidFractionSize;
};
exports.validatePriceValue = validatePriceValue;
//# sourceMappingURL=helpers.js.map